<template>
  <div class="appIndex" :class="{'isAppIndex': isAppIndex}">
    <menuframe></menuframe>
    <div id="frameContent">
      <div class="fc_child">
        <div class="placeHolderDOM"></div>
        <div class="contentimg" v-if="isAppIndex == true">
          <!--<img class="imgStyle" src="/static/img/appIndex-bg.jpg">-->
          <div class="allTitle">
            <div class="title">客户信息查询</div>
            <div class="demo-input-suffix">
              <el-input
                style="width: 360px; margin-top: 10px;"
                placeholder="请输入要查询的客户手机号"
                @change="submitSearch()"
                @keydown.enter.native="searchEnterFun"
                v-model="searchParams.mobile"
              >
                <el-button slot="append" @click="keySearch" icon="el-icon-search"></el-button>
              </el-input>
            </div>
          </div>
          <!--统计-->
          <!-- <div v-if="userType !== 2">
            <div class="allTitle" v-if="isCrmYichuang">
              <div class="title">待呼叫任务</div>
              <table class="a_table">
                <tr v-if="titleLength > 0">
                  <th>共计 {{titleLength}}个，分别是：</th>
                  <th v-for="(item, index) in titleData" :key="index"><div class="p_name">{{item.taskName}}</div>  {{item.taskNums}}个</th>
                </tr>
                <tr v-else>
                  <th>共计 0个</th>
                </tr>
              </table>
              <el-table :data="tableData" style="width: 100%;font-size:14px;">
                <el-table-column prop="userName" label="客户姓名" width=""></el-table-column>
                <el-table-column prop="taskPhone" label="手机号" width=""></el-table-column>
                <el-table-column prop="type" label="类型" width="">
                  <template slot-scope="scope">
                    <span v-if="scope.row.userSource == 0">双签用户</span>
                    <span v-if="scope.row.userSource == 1">注册用户</span>
                  </template>
                </el-table-column>
                <el-table-column prop="taskDetailName" label="所属任务"></el-table-column>
              </el-table>
              <table class="b_table">
                <tr @click="goLookAll">查看全部>></tr>
              </table>
            </div>
            <div class="allTitle" v-else><div class="title">您还没有绑定逸创账号，请先去逸创后台创建</div></div>
            <div class="bottom">
              <div class="list" @click="goMyclient(0)">
                <div class="t" v-if="countData.countNewVipMember">{{countData.countNewVipMember}}</div>
                <div class="t" v-else>0</div>
                <div class="b">昨日新增用户</div>
              </div>
              <div class="list" @click="goMyclient(1)">
                <div class="t" v-if="countData.vipExpire">{{countData.vipExpire}}</div>
                <div class="t" v-else>0</div>
                <div class="b">VIP即将到期用户</div>
              </div>
              <div class="list" @click="goMyclient(2)">
                <div class="t" v-if="countData.vehInspectExpire">{{countData.vehInspectExpire}}</div>
                <div class="t" v-else>0</div>
                <div class="b">审车即将到期用户</div>
              </div>
              <div class="list" @click="goMyclient(3)">
                <div class="t" v-if="countData.insuranceExpire">{{countData.insuranceExpire}}</div>
                <div class="t" v-else>0</div>
                <div class="b">保险即将到期用户</div>
              </div>
            </div>
          </div> -->
        </div>
        <div class="contentDOM">
          <div class="crumb" v-if="$route.name != 'appIndex'">
            <span
              :class="{'active': currentRouteName == 'appIndex'}"
              @click="gotoMenu({routeName: 'appIndex'})"
            >首页</span>
            <i v-if="currentRouteName != 'appIndex'">/</i>
            <template v-for="(item, index) in crumbArr">
              <span
                :class="{'active': currentRouteName == item.routeName || currentRoutePath == item.iframeUrl}"
                @click="gotoMenu(item)"
                :key="item.routeName"
              >{{item.title}}</span>
              <i :key="index" v-if="crumbArr.length > 0 && index != crumbArr.length - 1">/</i>
            </template>
          </div>
          <router-view v-if="curFirstPath == '/app'"></router-view>
          <frame-admin v-if="curFirstPath == '/admin'"></frame-admin>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { devCode } from '@/http/baseUrl';
export default {
  name: 'appIndex',
  components: {
    menuframe: require('./base/menuframe').default,
    frameAdmin: require('./frame/admin.vue').default
  },
  data () {
    return {
      isAppIndex: false,
      crumbArr: [],
      managerId: '',
      currentRouteName: '',
      currentRoutePath: '',
      curFirstPath: '',
      countData: '',
      time1: '',
      time2: '',
      vehType: '', // 审车到期 0不限 1:1个月以下 2:1-3个月 3:3到5个月 4:5个月以上
      insuranceType: '', // 保险到期 0不限 1:2年以内 2:2-6年 3:6-15年 4:15年以上
      vipType: '', // VIP到期 0不限 1:2年以内 2:2-6年 3:6-15年 4:15年以上
      searchParams: {
        mobile: ''
      },
      update: '',
      titleData: [],
      tableData: [],
      isCrmYichuang: true,
      titleLength: '',
      currentPage: 1,
      totalResult: 0,
      totalResult1: 0,
      totalPage: 0,
      userType: ''
    };
  },
  watch: {
    '$store.state.crumbArr' (val) {
      this.crumbArr = val;
      this.currentRouteName = this.$route.name;
      this.currentRoutePath = this.$route.path;
      let obj = this.$route.path.indexOf('customer');
      if (obj !== -1) {
        let newData = {
          title: '客户信息查询',
          routeName: 'customer'
        };
        this.crumbArr.concat(newData);
        console.log('+++++++++++++', this.crumbArr);
      }
    },
    $route (to, from) {
      this.curFirstPath = this.$route.path.match(/^\/[a-z]+/)[0];
      this.$store.state.iframeUrl = this.$route.path.split(
        this.curFirstPath
      )[1];
      if (to.name === 'appIndex') {
        this.isAppIndex = true;
      } else {
        this.isAppIndex = false;
      }
    }
  },
  created () {
    this.curFirstPath = this.$route.path.match(/^\/[a-z]+/)[0];
    this.$store.state.iframeUrl = this.$route.path.split(this.curFirstPath)[1];
    if (this.$route.name === 'appIndex') {
      this.isAppIndex = true;
    } else {
      this.isAppIndex = false;
    }
    /* this.axios.get(`/doubleTask/getManagerId`, {}).then(res => {
      this.managerId = res.data.resultData.managerId;
      this.userType = res.data.resultData.userType;
      this.getData();
      this.getManager();
    }); */
    this.$nextTick(() => {
      this.crumbArr = this.$store.state.crumbArr;
      this.currentRouteName = this.$route.name;
    });
  },
  methods: {
    gotoMenu (obj) {
      console.log('000000000000000', obj);
      if (this.currentRouteName === obj.routeName) return;
      if ('iframeUrl' in obj) {
        this.$router.push({path: obj.iframeUrl, query: {managerId: this.managerId}});
      } else {
        this.$router.push({name: obj.routeName, params: {managerId: this.managerId}});
      }
    },
    // 获取数据
    getData () {
      this.axios
        .get(`/member/countMemberData`, {
          params: {
            managerId: this.managerId ? this.managerId : ''
          }
        })
        .then(res => {
          if (res.data.isSuccess) {
            this.countData = res.data.resultData;
          } else {
            this.$message.warning(res.data.message);
          }
        });
    },
    // 获取manageID 当前任务 任务详细
    getManager () {
      this.axios.get('/doubleTask/CurrTaskStatics' + devCode, {
        params: {
          managerId: this.managerId
        }
      }).then(res => {
        if (res.data.isSuccess) {
          this.titleData = res.data.resultData.taskDetailStaisticsList;
          this.titleLength = res.data.resultData.taskDetailStaisticsList.length;
        } else {
          this.$message.error(res.data.message);
          this.isCrmYichuang = false;
        }
      });
      this.axios.get('/doubleTask/CurrTaskDetail' + devCode, {
        params: {
          managerId: this.managerId,
          pageIndex: this.searchParams.pageIndex,
          pageSize: 8
        }
      }).then(res => {
        if (res.data.isSuccess) {
          this.tableData = res.data.resultData.pageListData;
          this.totalResult = res.data.resultData.totalResult;
          this.totalPage = res.data.resultData.totalPage;
        } else {
          this.$message.error(res.data.message);
          this.isCrmYichuang = false;
        }
      });
    },
    goLookAll (e) {
      this.$router.push({
        name: 'myTask',
        query: {insuranceType: this.insuranceType}
      });
    },
    goMyclient (e) {
      if (e === 0) { // 获取昨日新增
        var losed = this.GetDateStr(-1);
        this.time1 = losed + ' ' + '00:00:00';
        this.time2 = losed + ' ' + '23:59:59';
        this.$router.push({
          name: 'myClient',
          query: {time1: this.time1, time2: this.time2}
        });
      } else if (e === 1) { // vip到期
        this.vipType = 1;
        this.$router.push({
          name: 'myClient',
          query: {vipType: this.vipType}
        });
      } else if (e === 2) { // 审车到期
        this.vehType = 1;
        this.$router.push({
          name: 'myClient',
          query: {vehType: this.vehType}
        });
      } else if (e === 3) { // 保险到期
        this.insuranceType = 1;
        this.$router.push({
          name: 'myClient',
          query: {insuranceType: this.insuranceType}
        });
      }
    },
    // 搜索
    // 监听回车键搜索
    searchEnterFun (e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode === 11) {
        this.submitSearch();
      } else {
        console.log('错误输入执行结果', e);
      }
    },
    GetDateStr (AddDayCount) {
      var dd = new Date();
      dd.setDate(dd.getDate() + AddDayCount); // 获取AddDayCount天后的日期
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1; // 获取当前月份的日期
      var d = dd.getDate();
      return y + '-' + m + '-' + d;
    },
    keySearch () {
      if (this.searchParams.mobile === '') {
        return this.$message.warning('请输入手机号查询');
      } else {
        this.$router.push({
          name: 'customerCheck',
          query: {mobile: this.searchParams.mobile, managerId: this.managerId}
        });
      }
      this.update = new Date().getTime();
    },
    submitSearch () {
      if (this.searchParams.mobile === '') {
        return this.$message.warning('请输入手机号查询');
      } else {
        this.$router.push({
          name: 'customerCheck',
          query: {mobile: this.searchParams.mobile, managerId: this.managerId}
        });
      }
      this.update = new Date().getTime();
    }
  }
};
</script>
<style lang="scss" scoped>
.appIndex {
  width: 100%;
  height: 100%;
  position: relative;
}
.appIndex.isAppIndex {
  background-color: #f0f4fd;
}
#frameContent {
  position: relative;
  height: 100%;
  overflow: auto;
}
.fc_child {
  height: 100%;
  overflow: auto;
}
.contentDOM {
  margin-left: -20px;
}
.crumb {
  margin: 10px 0 0 20px;
  padding: 2px 10px;
  border-left: 2px solid $base-bgcolor-hover-blue;
  font-size: 14px;
  span {
    color: $theme-color-blue;
    cursor: pointer;
  }
  span.active {
    color: #999;
    cursor: default;
  }
  i {
    margin: 0 3px;
    font-style: normal;
  }
}
.contentimg {
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  background: #f0f4fd;
  background-position: bottom right;
}
.allTitle {
  margin-top: 20px;
}
.a_table {
  width: 100%;
  margin-top: 10px;
  background: #dedccc;
  font-size: 16px;
  line-height: 32px;
  font-weight: 500;
}
.a_table tr {
  display: flex;
  justify-content: normal;
  overflow: hidden;
}
.a_table tr th {
  font-weight: 500;
  display: flex;
  margin: 0 20px 0 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.a_table tr th .p_name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 250px;
}
.b_table {
  width: 100%;
  font-size: 16px;
  line-height: 32px;
  font-weight: 500;
  border-left: 1px solid #dddddd;
  border-right: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
}
.b_table tr {
  display: flex;
  justify-content: center;
  cursor: pointer;
}
.allTitle .title {
  font-size: 18px;
  font-weight: 550;
}
.bottom {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-right:20px;
  padding-bottom:20px;
}
.bottom .list {
  width: 20%;
  padding: 4% 0 4% 0;
  border-radius:2px 2px;
  display: flex;
  background: #dedccc;
  flex-direction: column;
  text-align: left;
  align-items: left;
  cursor:pointer;
  justify-content: center;
}
.bottom .list .t {
  font-size: 28px;
  font-weight: bold;
  margin-left: 50px;
}
.bottom .list .b {
  font-size: 16px;
  margin-left: 50px;
  margin-top: 10px;
}
</style>
<style>
.el-table thead {
  font-weight: 550;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue